export default __webpack_public_path__ + "static/media/selectedsearch.9dcad994.svg";